import { FundingOption } from '@varo/graphql-schema-types';
import { useFundingCallback } from 'features/onboarding/hooks/useFundingCallback';
import React from 'react';
import WalletPaySuccess from 'shared/patterns/walletPay/screens/WalletPaySuccess/WalletPaySuccess';

const GooglePaySuccess = () => {
  const { hasCallback, invokeCallback } = useFundingCallback(
    FundingOption.GooglePay,
  );
  const handleSuccess = hasCallback
    ? () => {
        invokeCallback({ success: true });
      }
    : undefined;

  return (
    <WalletPaySuccess
      analytics={{
        screenKey: 'onboarding/google-pay/google-pay-success',
        eventName: 'Google Pay Funding Completed',
        category: 'google_pay',
        flowName: 'google_pay_funding',
      }}
      onSuccess={handleSuccess}
      skipAutoNavigate={hasCallback}
    />
  );
};

export default GooglePaySuccess;
